/* Lovable Sortiment / All-products page interactions */
(function () {
  function init(root) {
    if (!root || root.__lvsInit) return;
    root.__lvsInit = true;

    /* ---------- smooth scroll helper ----------
       This theme sets html{scroll-behavior:smooth}, but native smooth + a rAF
       loop both stall when the tab isn't painting. So we animate manually with
       scroll-behavior forced to auto (each frame's set is instant), and add a
       setTimeout fallback that guarantees the final landing even if rAF is
       throttled (e.g. a background tab). */
    var scrollRAF = null;
    var scrollTimer = null;
    function setY(y) {
      var de = document.documentElement;
      de.style.scrollBehavior = "auto";
      window.scrollTo(0, y);
      de.scrollTop = y;
      document.body.scrollTop = y;
    }
    function smoothScrollTo(targetY, duration) {
      if (scrollRAF) cancelAnimationFrame(scrollRAF);
      if (scrollTimer) clearTimeout(scrollTimer);
      var de = document.documentElement;
      var start = window.pageYOffset || de.scrollTop || 0;
      var max = Math.max(de.scrollHeight, document.body.scrollHeight) - de.clientHeight;
      var end = Math.max(0, Math.min(targetY, max));
      var dist = end - start;
      if (Math.abs(dist) < 2) { setY(end); return; }
      var t0 = null;
      var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }; // easeInOutCubic
      function step(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / duration);
        setY(start + dist * ease(p));
        if (p < 1) scrollRAF = requestAnimationFrame(step);
      }
      scrollRAF = requestAnimationFrame(step);
      // fallback: land precisely even if frames never run (hidden/throttled tab)
      scrollTimer = setTimeout(function () {
        if (Math.abs((window.pageYOffset || de.scrollTop || 0) - end) > 4) setY(end);
      }, duration + 120);
    }

    /* ---------- intro read-more ---------- */
    var introToggle = root.querySelector("[data-intro-toggle]");
    var introMore = root.querySelector("[data-intro-more]");
    var introLabel = root.querySelector("[data-intro-label]");
    var intro = root.querySelector("[data-intro]");
    if (introToggle && introMore) {
      introToggle.addEventListener("click", function () {
        var open = introMore.hasAttribute("hidden");
        if (open) {
          introMore.removeAttribute("hidden");
          introToggle.setAttribute("aria-expanded", "true");
          if (introLabel) introLabel.textContent = "Weniger anzeigen";
        } else {
          introMore.setAttribute("hidden", "");
          introToggle.setAttribute("aria-expanded", "false");
          if (introLabel) introLabel.textContent = "Weiterlesen";
          if (intro) requestAnimationFrame(function () { intro.scrollIntoView({ behavior: "smooth", block: "start" }); });
        }
      });
    }

    /* ---------- category strip + nav arrows ---------- */
    var strip = root.querySelector("[data-strip] .lvc-strip__grid");
    var stripNext = root.querySelector("[data-strip-next]");
    if (strip && stripNext) {
      var syncArrow = function () {
        var overflow = strip.scrollWidth - strip.clientWidth;
        if (overflow <= 4) stripNext.setAttribute("hidden", "");
        else stripNext.removeAttribute("hidden");
      };
      stripNext.addEventListener("click", function () {
        var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
        if (atEnd) strip.scrollTo({ left: 0, behavior: "smooth" });
        else strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: "smooth" });
      });
      window.addEventListener("resize", syncArrow);
      window.addEventListener("load", syncArrow);
      if (window.ResizeObserver) { new ResizeObserver(syncArrow).observe(strip); }
      syncArrow();
      requestAnimationFrame(syncArrow);
      setTimeout(syncArrow, 300);
      root.__lvsSync = syncArrow;
    }
    /* ---------- category tiles scroll to their section on this page ---------- */
    var lvsSectionId = (root.id && root.id.indexOf("lvs-") === 0) ? root.id.slice(4) : (root.id || "");
    var lvsRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    if (lvsRoot.charAt(lvsRoot.length - 1) === "/") lvsRoot = lvsRoot.slice(0, -1);
    root.querySelectorAll("[data-scrollto]").forEach(function (tile) {
      var hash = tile.getAttribute("href") || "";
      var target = hash.charAt(0) === "#" ? document.getElementById(hash.slice(1)) : null;
      if (!target) {
        // No on-page section for this category (empty after de-dup). Do NOT hide the
        // tile -- hiding shrinks the strip so it never overflows and the slider arrow
        // never appears. Keep it visible and link it to the collection's own page.
        var rawId = hash.charAt(0) === "#" ? hash.slice(1) : "";
        var handle = (lvsSectionId && rawId.indexOf(lvsSectionId + "-") === 0) ? rawId.slice(lvsSectionId.length + 1) : "";
        if (handle && handle !== "top") {
          tile.setAttribute("href", lvsRoot + "/collections/" + handle);
          tile.removeAttribute("data-scrollto");
        } else {
          tile.style.display = "none";
        }
        return;
      }
      tile.addEventListener("click", function (e) {
        e.preventDefault();
        // A category tile must clear EVERY active filter/sort (type, price,
        // availability/"Best Seller") so the page returns to the grouped view
        // where the category sections exist. Then scroll to the clicked one.
        var changed = false;
        [typeSel, priceSel, availSel].forEach(function (s) {
          if (s && s.value) { s.value = ""; changed = true; }
        });
        if (sortSel && sortSel.value && sortSel.value !== "featured") { sortSel.value = "featured"; changed = true; }
        if (changed) {
          // apply() reads all selects and reflows SYNCHRONOUSLY on dispatch, so by
          // the next line the grouped layout (and the target's position) is current.
          // Don't wrap this in requestAnimationFrame: rAF stalls in a non-painting
          // tab, which is exactly why smoothScrollTo carries its own setTimeout fallback.
          (typeSel || priceSel || availSel || sortSel).dispatchEvent(new Event("change", { bubbles: true }));
        }
        var y = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - 24;
        smoothScrollTo(y, 600);
      });
    });
    // re-evaluate the strip arrow AFTER tiles are finalized + images settle
    if (root.__lvsSync) root.__lvsSync();

    var navScroller = root.querySelector("[data-nav-scroller]");
    var navPrev = root.querySelector("[data-nav-prev]");
    var navNext = root.querySelector("[data-nav-next]");
    if (navScroller && navPrev) navPrev.addEventListener("click", function () { navScroller.scrollBy({ left: -240, behavior: "smooth" }); });
    if (navScroller && navNext) navNext.addEventListener("click", function () { navScroller.scrollBy({ left: 240, behavior: "smooth" }); });

    /* ---------- grouped <-> flat filter + sort ---------- */
    var groupsWrap = root.querySelector("[data-groups]");
    var flatGrid = root.querySelector("[data-flat-grid]");
    var typeSel = root.querySelector("[data-filter-type]");
    var priceSel = root.querySelector("[data-filter-price]");
    var availSel = root.querySelector("[data-filter-avail]");
    var sortSel = root.querySelector("[data-sort]");
    var countEl = root.querySelector("[data-count]");
    var noResults = root.querySelector("[data-noresults]");

    if (groupsWrap) {
      var groups = Array.prototype.slice.call(groupsWrap.querySelectorAll("[data-catgroup]"));
      var cards = Array.prototype.slice.call(groupsWrap.querySelectorAll("[data-card]"));
      cards.forEach(function (c) { c.__home = c.parentElement; }); // remember origin grid

      var matchOf = function (c, tf, pf, af) {
        if (tf && c.getAttribute("data-cat") !== tf) return false;
        var price = parseInt(c.getAttribute("data-price"), 10) || 0; // cents
        if (pf === "u20" && !(price < 2000)) return false;
        if (pf === "20-40" && !(price >= 2000 && price <= 4000)) return false;
        if (pf === "o40" && !(price > 4000)) return false;
        var onSale = c.getAttribute("data-sale") === "1";
        var best = c.getAttribute("data-bestseller") === "1";
        if (af === "sale" && !onSale) return false;
        if (af === "bestseller" && !best) return false;
        return true;
      };
      var sortCards = function (arr, sort) {
        if (sort === "price-asc") arr.sort(function (a, b) { return a.getAttribute("data-price") - b.getAttribute("data-price"); });
        else if (sort === "price-desc") arr.sort(function (a, b) { return b.getAttribute("data-price") - a.getAttribute("data-price"); });
        else if (sort === "name") arr.sort(function (a, b) { return (a.getAttribute("data-name") || "").localeCompare(b.getAttribute("data-name") || "", "de"); });
        return arr;
      };

      var apply = function () {
        var tf = typeSel ? typeSel.value : "";
        var pf = priceSel ? priceSel.value : "";
        var af = availSel ? availSel.value : "";
        var sort = sortSel ? sortSel.value : "featured";
        var isFiltered = !!(tf || pf || af) || (sort && sort !== "featured");

        var visible = cards.filter(function (c) { return matchOf(c, tf, pf, af); });

        if (isFiltered) {
          // flat view: hide groups, reflow matching cards into the flat grid
          groups.forEach(function (g) { g.setAttribute("hidden", ""); });
          sortCards(visible, sort);
          visible.forEach(function (c) { flatGrid.appendChild(c); });
          flatGrid.removeAttribute("hidden");
        } else {
          // grouped view: restore every card to its home grid in original order
          cards.forEach(function (c) { if (c.__home && c.parentElement !== c.__home) c.__home.appendChild(c); });
          groups.forEach(function (g) { g.removeAttribute("hidden"); });
          flatGrid.setAttribute("hidden", "");
        }

        if (countEl) countEl.textContent = visible.length;
        if (noResults) { if (visible.length === 0) noResults.removeAttribute("hidden"); else noResults.setAttribute("hidden", ""); }
      };

      [typeSel, priceSel, availSel, sortSel].forEach(function (s) { if (s) s.addEventListener("change", apply); });
      apply(); // set initial count
    }

    /* ---------- scroll to top ---------- */
    var toTop = root.querySelector("[data-totop]");
    if (toTop) {
      var onScroll = function () { toTop.classList.toggle("is-visible", window.scrollY > 400); };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
      toTop.addEventListener("click", function () { smoothScrollTo(0, 500); });
    }
  }

  function boot() { document.querySelectorAll(".lvs").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector ? e.target.querySelector(".lvs") : null;
    if (el) init(el);
  });
})();